export default __webpack_public_path__ + "static/media/IMG_1820.6c6cc3b7.jpeg";